module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1048-915ec713b0cc0c15198629d99ac680a7.png";